/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentColor } from './AppointmentColor';
import {
    AppointmentColorFromJSON,
    AppointmentColorFromJSONTyped,
    AppointmentColorToJSON,
    AppointmentColorToJSONTyped,
} from './AppointmentColor';
import type { PersonPortal } from './PersonPortal';
import {
    PersonPortalFromJSON,
    PersonPortalFromJSONTyped,
    PersonPortalToJSON,
    PersonPortalToJSONTyped,
} from './PersonPortal';
import type { PersonAppointment } from './PersonAppointment';
import {
    PersonAppointmentFromJSON,
    PersonAppointmentFromJSONTyped,
    PersonAppointmentToJSON,
    PersonAppointmentToJSONTyped,
} from './PersonAppointment';
import type { GenderEnum } from './GenderEnum';
import {
    GenderEnumFromJSON,
    GenderEnumFromJSONTyped,
    GenderEnumToJSON,
    GenderEnumToJSONTyped,
} from './GenderEnum';
import type { InstituteRoomBadge } from './InstituteRoomBadge';
import {
    InstituteRoomBadgeFromJSON,
    InstituteRoomBadgeFromJSONTyped,
    InstituteRoomBadgeToJSON,
    InstituteRoomBadgeToJSONTyped,
} from './InstituteRoomBadge';

/**
 * Response for appointment information
 * @export
 * @interface AppointmentPropsResponse
 */
export interface AppointmentPropsResponse {
    /**
     * Unique identifier of the patient
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    patientId?: string;
    /**
     * Unique identifier of the patient relation
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    relationId?: string;
    /**
     * Unique identifier of the doctor
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    doctorUuid?: string;
    /**
     * Firstname and Lastname of doctor
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    doctor?: string;
    /**
     * Firstname and Lastname of patient
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    patient?: string;
    /**
     * Firstname of patient
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    firstname?: string;
    /**
     * Lastname (uppercase) of patient
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    lastname?: string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof AppointmentPropsResponse
     */
    gender?: GenderEnum;
    /**
     * Birthdate of patient
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    birthdate?: string;
    /**
     * Appointment start time
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    appointmentTime?: string;
    /**
     * Appointment duration (min)
     * @type {number}
     * @memberof AppointmentPropsResponse
     */
    duration?: number;
    /**
     * Appointment comment
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    comment?: string;
    /**
     * Unique identifier of the appointment
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    appointmentId?: string;
    /**
     * Patient arrival time
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    arrivalTime?: string | null;
    /**
     * Patient departure time
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    departureTime?: string | null;
    /**
     * appointment status
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    status?: AppointmentPropsResponseStatusEnum;
    /**
     * Unique identifier of the appointment type
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    appointmentTypeId?: string;
    /**
     * 
     * @type {AppointmentColor}
     * @memberof AppointmentPropsResponse
     */
    color?: AppointmentColor;
    /**
     * waiting room name
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    waitingRoom?: string;
    /**
     * Date when the appointment was create
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    created?: string;
    /**
     * Author of the appointment creation
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    createdBy?: string;
    /**
     * Unique identifier of the user from the portal
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    portalUserUuid?: string;
    /**
     * Firstname and lastname of user from the portal
     * @type {string}
     * @memberof AppointmentPropsResponse
     */
    portalUserName?: string;
    /**
     * 
     * @type {PersonAppointment}
     * @memberof AppointmentPropsResponse
     */
    personAppointment?: PersonAppointment;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentPropsResponse
     */
    failedToFetchPortalPatientData?: boolean;
    /**
     * 
     * @type {PersonPortal}
     * @memberof AppointmentPropsResponse
     */
    portalUser?: PersonPortal;
    /**
     * 
     * @type {InstituteRoomBadge}
     * @memberof AppointmentPropsResponse
     */
    roomBadge?: InstituteRoomBadge;
}


/**
 * @export
 */
export const AppointmentPropsResponseStatusEnum = {
    WaitingRoom: 'WAITING_ROOM',
    Scheduled: 'SCHEDULED',
    Honoured: 'HONOURED',
    NotHonoured: 'NOT_HONOURED',
    ToValidate: 'TO_VALIDATE',
    Cancelled: 'CANCELLED'
} as const;
export type AppointmentPropsResponseStatusEnum = typeof AppointmentPropsResponseStatusEnum[keyof typeof AppointmentPropsResponseStatusEnum];


/**
 * Check if a given object implements the AppointmentPropsResponse interface.
 */
export function instanceOfAppointmentPropsResponse(value: object): value is AppointmentPropsResponse {
    return true;
}

export function AppointmentPropsResponseFromJSON(json: any): AppointmentPropsResponse {
    return AppointmentPropsResponseFromJSONTyped(json, false);
}

export function AppointmentPropsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentPropsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'] == null ? undefined : json['patientId'],
        'relationId': json['relationId'] == null ? undefined : json['relationId'],
        'doctorUuid': json['doctorUuid'] == null ? undefined : json['doctorUuid'],
        'doctor': json['doctor'] == null ? undefined : json['doctor'],
        'patient': json['patient'] == null ? undefined : json['patient'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'gender': json['gender'] == null ? undefined : GenderEnumFromJSON(json['gender']),
        'birthdate': json['birthdate'] == null ? undefined : json['birthdate'],
        'appointmentTime': json['appointmentTime'] == null ? undefined : json['appointmentTime'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'appointmentId': json['appointmentId'] == null ? undefined : json['appointmentId'],
        'arrivalTime': json['arrivalTime'] == null ? undefined : json['arrivalTime'],
        'departureTime': json['departureTime'] == null ? undefined : json['departureTime'],
        'status': json['status'] == null ? undefined : json['status'],
        'appointmentTypeId': json['appointmentTypeId'] == null ? undefined : json['appointmentTypeId'],
        'color': json['color'] == null ? undefined : AppointmentColorFromJSON(json['color']),
        'waitingRoom': json['waitingRoom'] == null ? undefined : json['waitingRoom'],
        'created': json['created'] == null ? undefined : json['created'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'portalUserUuid': json['portalUserUuid'] == null ? undefined : json['portalUserUuid'],
        'portalUserName': json['portalUserName'] == null ? undefined : json['portalUserName'],
        'personAppointment': json['personAppointment'] == null ? undefined : PersonAppointmentFromJSON(json['personAppointment']),
        'failedToFetchPortalPatientData': json['failedToFetchPortalPatientData'] == null ? undefined : json['failedToFetchPortalPatientData'],
        'portalUser': json['portalUser'] == null ? undefined : PersonPortalFromJSON(json['portalUser']),
        'roomBadge': json['roomBadge'] == null ? undefined : InstituteRoomBadgeFromJSON(json['roomBadge']),
    };
}

export function AppointmentPropsResponseToJSON(json: any): AppointmentPropsResponse {
    return AppointmentPropsResponseToJSONTyped(json, false);
}

export function AppointmentPropsResponseToJSONTyped(value?: AppointmentPropsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'relationId': value['relationId'],
        'doctorUuid': value['doctorUuid'],
        'doctor': value['doctor'],
        'patient': value['patient'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'gender': GenderEnumToJSON(value['gender']),
        'birthdate': value['birthdate'],
        'appointmentTime': value['appointmentTime'],
        'duration': value['duration'],
        'comment': value['comment'],
        'appointmentId': value['appointmentId'],
        'arrivalTime': value['arrivalTime'],
        'departureTime': value['departureTime'],
        'status': value['status'],
        'appointmentTypeId': value['appointmentTypeId'],
        'color': AppointmentColorToJSON(value['color']),
        'waitingRoom': value['waitingRoom'],
        'created': value['created'],
        'createdBy': value['createdBy'],
        'portalUserUuid': value['portalUserUuid'],
        'portalUserName': value['portalUserName'],
        'personAppointment': PersonAppointmentToJSON(value['personAppointment']),
        'failedToFetchPortalPatientData': value['failedToFetchPortalPatientData'],
        'portalUser': PersonPortalToJSON(value['portalUser']),
        'roomBadge': InstituteRoomBadgeToJSON(value['roomBadge']),
    };
}

